export default __webpack_public_path__ + "static/media/dark-logo.c4b3733b.png";